"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyMortgages$ = exports.CompaniesCompanyMortgages$outboundSchema = exports.CompaniesCompanyMortgages$inboundSchema = void 0;
exports.companiesCompanyMortgagesToJSON = companiesCompanyMortgagesToJSON;
exports.companiesCompanyMortgagesFromJSON = companiesCompanyMortgagesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.CompaniesCompanyMortgages$inboundSchema = z.object({
    num_mort_charges: z.nullable(z.number().int()),
    num_mort_outstanding: z.nullable(z.number().int()),
    num_mort_part_satisfied: z.nullable(z.number().int()),
    num_mort_satisfied: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "num_mort_charges": "numMortCharges",
        "num_mort_outstanding": "numMortOutstanding",
        "num_mort_part_satisfied": "numMortPartSatisfied",
        "num_mort_satisfied": "numMortSatisfied",
    });
});
/** @internal */
exports.CompaniesCompanyMortgages$outboundSchema = z.object({
    numMortCharges: z.nullable(z.number().int()),
    numMortOutstanding: z.nullable(z.number().int()),
    numMortPartSatisfied: z.nullable(z.number().int()),
    numMortSatisfied: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        numMortCharges: "num_mort_charges",
        numMortOutstanding: "num_mort_outstanding",
        numMortPartSatisfied: "num_mort_part_satisfied",
        numMortSatisfied: "num_mort_satisfied",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyMortgages$;
(function (CompaniesCompanyMortgages$) {
    /** @deprecated use `CompaniesCompanyMortgages$inboundSchema` instead. */
    CompaniesCompanyMortgages$.inboundSchema = exports.CompaniesCompanyMortgages$inboundSchema;
    /** @deprecated use `CompaniesCompanyMortgages$outboundSchema` instead. */
    CompaniesCompanyMortgages$.outboundSchema = exports.CompaniesCompanyMortgages$outboundSchema;
})(CompaniesCompanyMortgages$ || (exports.CompaniesCompanyMortgages$ = CompaniesCompanyMortgages$ = {}));
function companiesCompanyMortgagesToJSON(companiesCompanyMortgages) {
    return JSON.stringify(exports.CompaniesCompanyMortgages$outboundSchema.parse(companiesCompanyMortgages));
}
function companiesCompanyMortgagesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompaniesCompanyMortgages$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompaniesCompanyMortgages' from JSON`);
}
//# sourceMappingURL=companiescompanymortgages.js.map